import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DbcListComponent,
} from './dbc-list/dbc-list.component';
import { DigitalBusinessCardRoutingModule } from './dbc.routing';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SkeletonLoaderComponent } from './dbc-list/skeleton-loader/skeleton-loader.component';
import { SwiperDirective } from '../directives/swiper.directive';
import { PipesModule } from '../pipe/pipe.module';
import { ShareScreenComponent } from './dbc-list/share-screen/share-screen.component';
import { MobileDrawerModule } from '../global-components/mobile-drawer/mobile-drawer.module';
import { ImageCaptureComponent } from './dbc-list/image-capture/image-capture.component';
import { ImageCaptureCreateLeadComponent } from './dbc-list/image-capture-create-lead/image-capture-create-lead.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProcessingLoaderComponent } from 'app/global-components/processing-loader/processing-loader.component';
import { LeadListComponent } from './dbc-list/lead-list/lead-list.component';
import { SkeletonLoaderLeadListComponent } from './dbc-list/skeleton-loader-lead-list/skeleton-loader-lead-list.component';
import { BottomNavComponent } from '../global-components/bottom-nav/bottom-nav.component';
import { DownloadCardsAppMobileNudgeModule } from '../global-components/download-cards-app-mobile-nudge/download-cards-app-mobile-nudge.module';

@NgModule({
    declarations: [
        DbcListComponent,
        SkeletonLoaderComponent,
        SwiperDirective,
        ShareScreenComponent,
        ImageCaptureComponent,
        ImageCaptureCreateLeadComponent,
        ProcessingLoaderComponent,
        LeadListComponent,
        SkeletonLoaderLeadListComponent,
        BottomNavComponent,
    ],
    imports: [
        CommonModule,
        DigitalBusinessCardRoutingModule,
        NgxSkeletonLoaderModule,
        PipesModule,
        MobileDrawerModule,
        ReactiveFormsModule,
        DownloadCardsAppMobileNudgeModule,
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DbcModule {}
